import { ChangeDetectionStrategy, Component, Input, OnInit, OnDestroy } from '@angular/core';

import {
  DeviceIds,
  Feature,
  FeatureCommands,
  FeaturePropertyKey,
  IsNumberValueProperty,
  SetNumberValueCommands,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { HemsStore, InstallationFeaturesStore } from '@store';
import { SUFFIX } from '../../../../../shared/common/units';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-hems-stepper-setting-option',
  templateUrl: './hems-stepper-setting-option.component.html',
  styleUrls: ['./hems-stepper-setting-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemsStepperSettingOptionComponent implements OnInit, OnDestroy {
  SUFFIX = SUFFIX;
  ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() feature: Feature<IsNumberValueProperty, SetNumberValueCommands>;
  @Input() disabled = false;
  @Input() title: string;
  @Input() gtmAction: string;

  limits: number[];
  hemsGateway: string;
  constructor(
    private hemsStore: HemsStore,
    private gtmService: GTMService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    const steppedValue = this.feature as Feature<IsNumberValueProperty, SetNumberValueCommands>;
    const { min, max, stepping } = steppedValue.commands.setValue.params.value.constraints;
    this.limits = [];
    for (let i = min; i <= max; i += stepping) {
      this.limits.push(i);
    }
    this.hemsStore.hemsGatewaySerialIfNoError$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((gwSerial) => (this.hemsGateway = gwSerial));
  }

  onSelectFeatureValue(value: string): void {
    if (!this.disabled) {
      this.installationFeaturesStore.updateFeature(
        this.feature.feature,
        value,
        FeaturePropertyKey.value,
        null,
        FeatureCommands.setValue,
        this.hemsGateway,
        DeviceIds.Hems
      );

      this.gtmService.track('onSelect', this.gtmAction, 'hems');
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
